import _ from 'underscore';

const DEFAULT_MIN_LENGTH = 8;
const DEFAULT_MIN_CHARSETS = 3;

export default {
  computed: {
    passwordRules() {
      return this.$store.getters.passwordRules || {};
    },
    passwordCharsets() {
      return _(this.passwordRules?.charsets || []).sortBy(cs => cs.ordinal);
    },
    passwordValue() {
      return (this.password || '').trim();
    },
    unmetPasswordCharsets() {
      return this.passwordCharsets.filter(cs => !cs.test(this.passwordValue));
    },
    passwordStrengthCount() {
      return this.passwordCharsets.reduce((sum, cs) => sum + (cs.test(this.passwordValue) ? 1 : 0), 0);
    },
    isStrongPassword() {
      return (
        this.passwordValue.length >= (this.passwordRules.minLength || DEFAULT_MIN_LENGTH) &&
        this.passwordStrengthCount >= (this.passwordRules.minCharsets || DEFAULT_MIN_CHARSETS)
      );
    },
    passwordFeedback() {
      const value = this.passwordValue;
      if (!value.length) {
        return 'Password is required';
      }
      if (value.length < (this.passwordRules.minLength || DEFAULT_MIN_LENGTH)) {
        return 'Password is too short';
      }
      if (this.passwordStrengthCount < (this.passwordRules.minCharsets || DEFAULT_MIN_CHARSETS)) {
        return 'Password does not meet complexity requirements';
      }
      return false;
    }
  }
};
